import { Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomBox from '../CommonComp/CustomBox/CustomBox'
import AllUserList from './AllUserList';
import BuyerUserList from './BuyerUserList';
import TemporaryUserList from './TemporaryUserList';
import UserAllDetail from './UserAllDetail';
import { useParams, useSearchParams } from 'react-router-dom';
import UserWishlistData from './UserWishlistData';
import UserCartData from './UserCartData';
import UserOutStandingData from './UserOutStandingData';
import UserActiveIvsOrderData from './UserActiveIvsOrderData';
import UserImageDownloadHistory from './UserImageDownloadHistory';
import UserPrivllegeImageDownloadHistory from './UserPrivllegeImageDownloadHistory';
import { isUserPrivilleged } from '../../Services/userApis';
import ResetPassword from './ResetPassword';

function SelectedUserTabBody({activeTab}) {
  const {userId}=useParams();
  const [isPrivillege,setIsPrivillege]=useState(null);
  useEffect(()=>{
    checkingPrivillege()
  },[userId])

  const checkingPrivillege=async()=>{
    let resp=await isUserPrivilleged({user_id:userId});
    setIsPrivillege(resp?.data);
  }

  
  return (<>
    {activeTab==3 ||activeTab==4 || activeTab==5 || activeTab==6 || activeTab==7 || activeTab==8 ? 
    <CustomBox padding={0} sx={{minHeight: 200, display: "flex", justifyContent: "center", alignItems: "center"}}>
       {activeTab == 3 && <UserWishlistData/>}
       {activeTab == 4 && <UserCartData />}
       {activeTab == 5 && <UserOutStandingData />}
       {activeTab == 6 && <UserActiveIvsOrderData />}
       {activeTab == 7 && <UserImageDownloadHistory/>} 
       <>
       {activeTab == 8 && <UserPrivllegeImageDownloadHistory isPrivillege={isPrivillege}/>}
       </>
       
    </CustomBox>
    :""}
    {activeTab == 1 && <UserAllDetail />}
     {activeTab == 2 && <ResetPassword />}
     </>
  )
}

export default SelectedUserTabBody